import { SlotMutationPhase } from './types';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const AVAILABILITY_ERROR_MESSAGE =
  'We could not load availability. Please try again.';

export const SLOT_NOT_BOOKABLE_MESSAGE =
  'This patient already has another appointment at this time. Please select a different time.';

export const RESERVE_SLOT_ERROR_MESSAGE =
  'We could not reserve this appointment. Please try again.';

export const RELEASE_SLOT_ERROR_MESSAGE =
  'We could not release this time. Please try again.';

export const RELEASE_SLOTS_ERROR_MESSAGE =
  'We could not release the selected appointments. Please try again.';

export const MISSING_SESSION_ERROR_MESSAGE =
  'Something went wrong. Please try again later';

export const SLOT_PENDING_LABEL_PREFIX: Record<SlotMutationPhase, string> = {
  checking: 'Checking availability for',
  reserving: 'Reserving',
  releasing: 'Releasing',
  committed: 'Reserved',
};

export const NEXT_AVAILABILITY_SEARCH_MONTHS = 3;

export const NEXT_AVAILABILITY_REQUEST_DELAY_MS = 300;

export const SLOT_COMMIT_BEAT_MS = 600;

export const LOADING_AVAILABILITY_MESSAGE = 'Loading availabilities...';

export const SEARCHING_AVAILABILITY_MESSAGE = 'Searching for availabilities...';

export const VIEW_NEXT_AVAILABILITY_LABEL_PREFIX =
  'View Next Availabilities on';

export const SEARCH_AGAIN_BUTTON_LABEL =
  'Find next availabilities within 3 months';

export const NO_AVAILABILITY_IN_RANGE_MESSAGE = 'No availabilities';

export const DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';

export const SHORT_DISPLAY_DATE_FORMAT = 'MMM DD';
